const FinalCTASection = () => {
  return (
    <section id="final-cta" className="final-cta-section">
      <div className="final-cta-glow" />
      <div className="final-cta-content">
        <div className="section-tag" style={{ color: 'var(--amber)', justifyContent: 'center' }}>
          <span>Ready to Begin?</span>
        </div>
        <h2 className="section-h" style={{ color: 'var(--white)', textAlign: 'center', maxWidth: 700, margin: '0 auto 20px', fontSize: 'clamp(2rem,5vw,4rem)' }}>
          You've Seen the <span className="a">Future.</span><br />
          Let's Build It Together.
        </h2>
        <p className="section-sub" style={{ color: 'var(--slate-light)', margin: '0 auto 44px', textAlign: 'center' }}>
          You've experienced the AI, calculated the ROI, found your solution. The only step left is the first one.
        </p>
        <div className="final-cta-btns">
          <a href="/#contact" className="btn-hero-p">Start Your AI Project →</a>
          <a href="/" className="btn-hero-s">← Back to Main Site</a>
        </div>
      </div>
    </section>
  );
};

export default FinalCTASection;
